module.exports = "/images/PE.png?04e99ec40d135a9b186071b67c6c7e4b";